import { ApiBase } from '../api-base'

export class CompanyServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/contractor/companies',
      name: 'company',
      successPath: '/companies'
    })
  }

  /**
   * @param {Object} params
   * @param {Integer} params.page
   * @param {String} params.q
   * @param {Integer} params.byStatus
   * @param {String} params.byAccredited
   * @param {Integer} params.byCompanySize
   * @returns {Promise}
   *
   */

  index({ page, q, byStatus, byAccredited, byCompanySize }) {
    const params = {}

    if (page) {
      params.page = page
    }

    if (q) {
      params.q = q
    }

    if (byAccredited) {
      params.by_accredited = byAccredited
    }

    if (byStatus) {
      params.by_status = byStatus
    }

    if (byCompanySize !== undefined) {
      params.by_company_size = byCompanySize
    }

    return this.api.get(`${this.resource}`, new URLSearchParams(params))
  }

  getSizes() {
    return this.api.get(`${this.resource}/sizes`)
  }
}
